module.exports = __webpack_public_path__ + "static/aloe-design-chair-poster-9be2e8444e30396730fc9ce727888797.jpg";